export default {
    instant: '100ms',
    fast: '200ms',
    normal: '300ms',
    slow: '400ms'
};
